// extracted by mini-css-extract-plugin
export var container = "index-module--container--d6A1u";
export var designation = "index-module--designation--IJemt";
export var headshot = "index-module--headshot---b+VF";
export var name = "index-module--name--OPor9";
export var profile = "index-module--profile--fi6cM";
export var profiles = "index-module--profiles--SdfKw";
export var title = "index-module--title--CERE0";